import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { StorageService } from './services/storage.service';
@Component({
  selector: 'app-layout',
  standalone: false,
  template: `
  @if (!loggedIn() && !authInProgress()) {
    <app-prelogin></app-prelogin>
  }
  <router-outlet></router-outlet>
  `,
  styles: [``]
})
export class LayoutComponent {
  private readonly storageService = inject(StorageService);
  // Signal so the view refreshes when MSAL/login callbacks update the state outside a template event.
  readonly loggedIn = toSignal(this.storageService.loggedIn$, { initialValue: false });
  readonly authInProgress = toSignal(this.storageService.authInProgress$, { initialValue: false });
}
